

export const getLayout = (next) => {
    let layout = {};
    if (next) {
        next(layout);
    }
}